export default __webpack_public_path__ + "static/media/incorrect3.bc08aab1.mp3";